import * as React from "react";
const SvgGlobe = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.618 12.75a13.676 13.676 0 0 0 2.602 7.308 8.256 8.256 0 0 1-6.436-7.308h3.834Zm1.503 0A12.142 12.142 0 0 0 12 19.892a12.041 12.041 0 0 0 2.873-7.142H9.121Zm5.753-1.5h-5.76a12.148 12.148 0 0 1 2.841-7.195 12.04 12.04 0 0 1 2.92 7.195Zm1.503 1.5a13.573 13.573 0 0 1-2.593 7.307 8.256 8.256 0 0 0 6.432-7.307h-3.84Zm3.84-1.5h-3.84a13.573 13.573 0 0 0-2.593-7.307 8.256 8.256 0 0 1 6.432 7.307Zm1.533.75c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12c0-5.337 4.288-9.673 9.608-9.749a10.46 10.46 0 0 1 .14-.001h.004c5.384.001 9.748 4.366 9.748 9.75Zm-17.966-.75a8.256 8.256 0 0 1 6.344-7.287 13.685 13.685 0 0 0-2.516 7.287H3.784Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgGlobe;
